const EXT_TO_TYPE = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const TYPE_TO_EXT = {
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'application/pdf': 'pdf',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
};

export const isFileInstance = (item) =>
    typeof File !== 'undefined' && item instanceof File;

export const isAttachedFile = (item) => {
    if (!item) return false;
    if (isFileInstance(item)) return item.size > 0 || !!item.name;
    return !!(item.isExisting && item.url);
};

export const attachmentList = (value) => {
    const list = Array.isArray(value) ? value : (value ? [value] : []);
    return list.filter(isAttachedFile);
};

const extensionOf = (name) => {
    if (!name || !name.includes('.')) return '';
    return name.split('.').pop().toLowerCase();
};

// Samsung's file picker often returns a File with an empty name and an empty MIME type.
export const normalizePickedFile = (file, index = 0) => {
    if (!isFileInstance(file)) return file;

    const extFromName = extensionOf(file.name);
    let type = file.type;
    if ((!type || type === 'application/octet-stream') && EXT_TO_TYPE[extFromName]) {
        type = EXT_TO_TYPE[extFromName];
    }

    let name = file.name;
    if (!name) {
        const ext = TYPE_TO_EXT[type] || extFromName || 'bin';
        name = `file-${Date.now()}-${index}.${ext}`;
    }

    if (name === file.name && type === file.type) return file;

    try {
        return new File([file], name, {
            type: type || file.type || 'application/octet-stream',
            lastModified: file.lastModified,
        });
    } catch (e) {
        return file;
    }
};

// Drop File objects and {} left behind when a draft JSON-encodes a File.
export const valueForDraft = (value) => {
    if (isFileInstance(value)) return undefined;
    if (Array.isArray(value)) {
        const kept = value.filter((item) => !isFileInstance(item) && isAttachedFile(item));
        return kept.length ? kept : undefined;
    }
    if (value && typeof value === 'object') {
        if (value.isExisting && value.url) return value;
        if (value.from || value.to) return value;
        return undefined;
    }
    return value;
};

export const draftValuesForSave = (values) => {
    const next = {};
    Object.keys(values || {}).forEach((key) => {
        const cleaned = valueForDraft(values[key]);
        if (cleaned !== undefined && cleaned !== '') next[key] = cleaned;
    });
    return next;
};

export const mergeDraftValues = (previous, incoming) => {
    const merged = {};
    Object.keys(incoming || {}).forEach((key) => {
        const cleaned = valueForDraft(incoming[key]);
        if (cleaned !== undefined && cleaned !== '') merged[key] = cleaned;
    });
    Object.keys(previous || {}).forEach((key) => {
        const current = previous[key];
        if (isFileInstance(current) || (Array.isArray(current) && current.some(isFileInstance))) {
            merged[key] = current;
        }
    });
    return merged;
};
